module.exports = __webpack_public_path__ + "static/img/companyRight.156da7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyRight.png
// module id = 0Z/T
// module chunks = 0